import { IApplicationState } from '../../../types/redux';
import { IRegionsData } from '../../../types/regions_data';

export const selectRegionsData = (state: IApplicationState): IRegionsData => {
  return state.mainpage.regionsData;
};
